// extracted by mini-css-extract-plugin
module.exports = {"about":"style-module--about--2Lm4_"};